import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  ProjectsFacade,
  formatNumber,
  nonNegativeValidator,
  scrollToSpecific,
  debounce,
  onKeyDown,
  getRolesAndPermission,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  DISABLED_TRANSPORT_MESSAGE,
  DistanceTypeEnum,
  GuideTourEnum,
  commonEnum,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ColDef } from 'ag-grid-community';
import { ProjectScenarioFillingDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-fill-data/project-scenario-filling-data-grid.service';
import { cloneDeep } from 'lodash';
import { GridIconComponent } from '../grid-icon/grid-icon.component';
import { CustomFillingsDataGridService } from '@piqet-angular/features';
import { ActivatedRoute } from '@angular/router';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { TitleCasePipe } from '@angular/common';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Observable, Subject, Subscription, forkJoin, take } from 'rxjs';
import { MapsAPILoader } from '@agm/core';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FeatureCodes } from 'libs/shared/src/lib/constants';
@Component({
  selector: 'piqet-angular-new-add-project-scenario-fill-data',
  templateUrl: './new-add-project-scenario-fill-data.component.html',
  styleUrls: ['./new-add-project-scenario-fill-data.component.scss'],
  providers: [TitleCasePipe],
})
export class NewAddProjectScenarioFillDataComponent implements OnDestroy {
  pageNumber: number = 1;
  searchValue: any;
  selectedCities: any;
  pageNumberProduct: number = 1;
  searchValueProduct: any;
  selectedCitiesProduct: any;
  isLoading = false;
  isLoadingProduct = false;
  lastItem: any;
  lastItemProduct: any;
  showDropdownFreight = false;
  fillingProcessColumnDefs!: ColDef[];
  transportColumnDefs!: ColDef[];
  distanceProductColumnDefs!: ColDef[];
  transportProductColumnDefs!: ColDef[];
  modalLabel: any;
  transportFreightModeList: any;
  customFreightData: any;
  fillingData: any;
  cityId: any;
  componentSubmitted: any;
  productSubmitted: any;
  fillingProcess: any;
  transportModeId: any;
  transportModeIdProduct: any;
  transportModeNameProduct: any;
  selectedBox: any;
  selectedProductBox: any;
  submitted: any;
  transportModeName: any;
  fillingSubmitted: any;
  tempData: any = [];
  customScenarioId: any;
  transportModeDescription: any;
  transportModeDescriptionProduct: any;
  transportIcons: any;
  transportProductIcons: any;
  dataListHolder: any;
  transportaionId: any = 2; // For transportation ID (Manual location, distance, custom) RECHECK
  productTransportaionId: any; // For product ID
  keyword = 'name';
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  packageAccountedProductId: any; // To hide/show product section
  setOriginsubmitted = false;
  setDestinationsubmitted = false;
  setDestinationProducsubmitted = false;
  countryList: any;
  location: any;
  isShowPort = false;
  isShowPortProduct = false;
  scenarioAddEditForm!: FormGroup;
  isProductContent: boolean = false;
  selectedProcess: any;
  selectedEnergyItem: any;
  transportModeItems: any;
  transportModeList: any;
  transportModeListProduct: any;
  customTransportModeList: any;
  productLossList: any;
  selectedProductLoss: any;
  isCustomTruck = false;
  isCustomTruckProduct = false;
  componentColumnDefs: any;
  productColumnDefs: any;
  projectId: any;
  scenarioId: any;
  distanceColumnDefs: any;
  fillingProcessList: any;
  customTruckItems: any;
  customFreightColumnDefs: any;
  setOriginProductsubmitted: any;
  selectedCustomFillingItem: any;
  transportModeErr: boolean = false;
  transportModeErrDistance: boolean = false;
  transportModeErrDistanceProd: boolean = false;
  transportationId: any;
  productItems: any;
  componentIds: any; // For selected component Ids
  isShowDistantField = false;
  customTransportList: any;
  isShowCustomTransportList = false;
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  selectCustomProduct = false;
  selectDistanceProduct = false;
  selectLocationProduct = false;
  selectedCountry: any;
  selectedProductItem: any;
  isValidPort: any;
  isValidPortProduct: any;
  messageType: any;
  messageTypeProduct: any;
  disableOriginProduct: boolean = false;
  disableDestinationProduct: boolean = false;
  keywordAuto: string = '';
  wholeData: any = [
    {
      displayName: 'Based on location',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
      productTransportaionId: 2,
    },
    {
      displayName: 'Based on distance',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
      productTransportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
      productTransportaionId: 4,
    },
  ];
  wholeDataProduct: any = [
    {
      displayName: 'Based on location',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
      productTransportaionId: 2,
    },
    {
      displayName: 'Based on distance',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
      productTransportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
      productTransportaionId: 4,
    },
  ];
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  TransportationEnumProduct = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  @Output() saveNewMyProjectFillingEvent = new EventEmitter<any>();
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  @ViewChild('autoForOriginProduct') autoForOriginProduct: any;
  @ViewChild('autoForDestinationProduct') autoForDestinationProduct: any;
  @ViewChild('compPopup') popover!: NgbPopover;
  @ViewChild('transportPopup') transportPopover!: NgbPopover;
  @ViewChild('locationPopup') locationPopover!: NgbPopover;
  @ViewChild('lossPopup') lossPopup!: NgbPopover;
  @ViewChild('myButton') buttonRef!: ElementRef;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
  };
  componentItems: any;
  seaDistance: any;
  productId: any;
  disableDestination: boolean = false;
  disableOrigin: boolean = false;
  percenteageMassLoad: any;
  percenteageMassLoadProd: any;
  setManualLocationDis: any;
  seaDistanceProduct: any;
  // for normal transport to converter
  checkIsOrginBtn = true;
  isCheckEditManudalDist = false;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  subscriptionProjectFillData!: Subscription;
  projectFilleditData: any;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProjectRetailManudalDistanceData!: Subscription;
  setApiResDistance = false;

  //  for product transport to converter
  checkIsOrginBtnProduct = true;
  isCheckEditManudalDistProduct = false;
  isCheckUpdateDestinationProduct = false;
  isCheckUpdateOriginProduct = false;
  subscriptionProjectFillDataProduct!: Subscription;
  projectFilleditDataProduct: any;
  setDestinationLocationDataProduct: any;
  getOriginAndDestinationEditDataProduct: any;
  subscriptionCheckDeleteRowDataProduct!: Subscription;
  subscriptionProjectRetailManudalDistanceDataProduct!: Subscription;
  setApiResDistanceProduct = false;
  setManualLocationDisForNextRecord: any;
  setManualLocationDisForNextRecordProduct: any;
  customFreightSelectData: any;
  customFreightSelectDataProduct: any;
  subscriptionSaveProjectManualDistanceFillingData!: Subscription;
  clearInputFieldProjectRetailManualDistanceFilling!: Subscription;
  // product
  subscriptionSaveProjectManualDistanceFillingProductData!: Subscription;
  clearInputFieldProjectRetailManualDistanceFillingProduct!: Subscription;
  productCustomTransportScenarioId: any;
  parentOrder: number = 1;
  parentOrderComponent: number = 1;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  private searchSubjectProduct = new Subject<string>();
  searchProduct$!: Observable<string>;
  isProductEmpty: boolean = true;
  isComponentEmpty: boolean = true;
  productMessage!: string;
  componentMessage!: string;
  showEdit: boolean = false;
  showCustomMaterialAccess: boolean = false;
  showCustomTruckAccess: boolean = false;
  showCustomConversionAccess: boolean = false;
  showCustomTransportAccess: boolean = false;
  showCustomFillingAccess: boolean = false;
  secondaryMarketDropdown: boolean = false;
  secondaryMarketStr = 'Sale to secondary market';

  secondaryDefaultValue: number = 10;
  secondaryMarketValueItem: any;
  FeatureCodes = FeatureCodes;
  isTourActive: boolean = false;

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  constructor(
    private modal: CustomModalService,
    public route: ActivatedRoute,
    public customFillingsDataGridService: CustomFillingsDataGridService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private mapsAPILoader: MapsAPILoader,
    public projectFacade: ProjectsFacade,
    public accessService: AccessPermissionService,
    private projectScenarioFillingDataGridService: ProjectScenarioFillingDataGridService,
    public projectsService: ProjectsService,
    private customService: CustomService
  ) {
    this.productMessage = DISABLED_TRANSPORT_MESSAGE.replace('{type}', 'product');
    this.componentMessage = DISABLED_TRANSPORT_MESSAGE.replace('{type}', 'component');
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.fillingData = this.modal?.modalService?.config?.initialState?.['fillingData'];
    this.scenarioId = this.modal?.modalService?.config?.initialState?.['scenarioId'];
    this.projectId = this.modal?.modalService?.config?.initialState?.['projectId'];
    this.transportationId = this.fillingData.transportationId || 2;
    this.fillingProcessColumnDefs =
      this.projectScenarioFillingDataGridService.fillingProcessColumn();
    this.transportColumnDefs = this.projectScenarioFillingDataGridService.locationColumn();
    this.transportProductColumnDefs =
      this.projectScenarioFillingDataGridService.locationColumnProduct();
    this.customFreightColumnDefs =
      this.projectScenarioFillingDataGridService.customSiteTransportColumn();
    this.componentColumnDefs = this.projectScenarioFillingDataGridService.addComponentColumn();
    this.productColumnDefs = this.projectScenarioFillingDataGridService.addProductColumn();
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs);
    this.distanceColumnDefs = this.distanceColumnDefs.splice(1);
    this.distanceProductColumnDefs = cloneDeep(this.transportProductColumnDefs);
    this.distanceProductColumnDefs = this.distanceProductColumnDefs.splice(1);
    this.distanceColumnDefs[2].editable = false;
    this.componentItems = this.fillingData?.componenetListItems;
    this.productTransportaionId = this.fillingData?.productTransportaionId || 2;
    this.productItems = this.fillingData?.productListItems;
    this.fillingProcess = this.fillingData?.energyProcessItems;
    this.packageAccountedProductId = this.fillingData?.packageAccountedProductId;
    this.countryList = this.fillingData?.regionlistIteams;
    this.productLossList = this.fillingData?.getProductLossListItems;
    this.transportModeList = this.fillingData?.transportModeItems;
    this.transportModeListProduct = this.fillingData?.transportModeItems;
    this.customTransportModeList = this.fillingData?.customTruckItems;
    this.transportFreightModeList = this.fillingData?.customtransportScenarioItems;
    this.productCustomTransportScenarioId = this.fillingData?.productCustomTransportScenarioId;
    this.secondaryMarketValueItem = this.fillingData?.secondaryMarketvalueItem;
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportationId == this.TransportationEnum[index].id;
    });
    this.selectedProductBox = this.TransportationEnumProduct.find((x: any, index: any) => {
      return this.productTransportaionId == this.TransportationEnumProduct[index].id;
    });
    this.productItems = this.fillingData?.productListItems;
    this.setCountry();
    this.setProductItem();
  }

  ngAfterViewInit() {
    if (!this.fillingData.isTourCompleted) this.triggerPopup();
  }

  async fingOriginAndDestination(id: any) {
    this.getOriginAndDestinationEditData = id;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.scenarioAddEditForm.patchValue({ origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.scenarioAddEditForm.patchValue({ destination: this.getOriginAndDestinationEditData });
    }
  }

  async fingOriginAndDestinationProduct(id: any) {
    this.getOriginAndDestinationEditDataProduct = id;
    if (this.checkIsOrginBtnProduct) {
      this.isCheckUpdateOriginProduct = true;
      this.scenarioAddEditForm.patchValue({
        originProduct: this.getOriginAndDestinationEditDataProduct,
      });
    } else {
      this.isCheckUpdateDestinationProduct = true;
      this.scenarioAddEditForm.patchValue({
        destinationProduct: this.getOriginAndDestinationEditDataProduct,
      });
    }
  }

  ngOnInit(): void {
    const pathName = this.route.snapshot.routeConfig?.path;
    this.showCustomMaterialAccess = getRolesAndPermission(
      rolesModuleName.customMaterial,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomConversionAccess = getRolesAndPermission(
      rolesModuleName.customConversion,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTruckAccess = getRolesAndPermission(
      rolesModuleName.customTrucks,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTransportAccess = getRolesAndPermission(
      rolesModuleName.customTransportScenario,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomFillingAccess = getRolesAndPermission(
      rolesModuleName.customFilling,
      mainModuleName.customModule
    )?.isOverview;
    this.showEdit = this.accessService.hasPermission('edit', pathName, 'packaging');
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((data: any) => {
      this.checkIsOrginBtn = false;
    });
    this.projectFacade.locationProcessProductData$.pipe(take(1)).subscribe((data: any) => {
      this.checkIsOrginBtnProduct = false;
    });

    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });

    this.searchProduct$ = debounce(this.searchSubjectProduct.asObservable(), this.debounceTimeMs);
    this.searchProduct$.subscribe(searchValue => {
      this.searchCitiesProduct(searchValue);
    });

    this.clearInputFieldProjectRetailManualDistanceFilling =
      this.projectScenarioFillingDataGridService.clearInputFieldProjectManualDistanceFillingData$.subscribe(
        (check: any) => {
          this.scenarioAddEditForm.controls['origin'].setValue(null);
          this.scenarioAddEditForm.controls['destination'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForLocation'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForDistance'].setValue(null);
          this.scenarioAddEditForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );

    this.subscriptionSaveProjectManualDistanceFillingData =
      this.projectScenarioFillingDataGridService.saveProjectManualDistanceWholesaleFillingData$.subscribe(
        (editData: any) => {
          this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
            data.length == 1 && editData[1] == 'manualLocation'
              ? this.setLocation()
              : !editData[0].isCheckManualDis
              ? this.setDestination()
              : this.addTransportLeg();
          });
        }
      );

    // product
    this.clearInputFieldProjectRetailManualDistanceFillingProduct =
      this.projectScenarioFillingDataGridService.clearInputFieldProjectManualDistanceFillingProduct$.subscribe(
        (check: any) => {
          this.scenarioAddEditForm.controls['originProduct'].setValue(null);
          this.scenarioAddEditForm.controls['destinationProduct'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForLocationProduct'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].setValue(null);
          this.scenarioAddEditForm.controls['distanceProduct'].setValue('');
          this.isCheckUpdateDestinationProduct = false;
          this.isCheckUpdateOriginProduct = false;
          this.isCheckEditManudalDistProduct = false;
          this.checkIsOrginBtnProduct = false;
        }
      );

    this.subscriptionSaveProjectManualDistanceFillingProductData =
      this.projectScenarioFillingDataGridService.saveProjectManualDistanceWholesaleFillingProductData$.subscribe(
        (editData: any) => {
          this.projectFacade.locationProcessProductData$
            .pipe(take(1))
            .subscribe(async (data: any) => {
              data.length == 1 && editData[1] == 'manualLocation'
                ? this.setLocationProduct()
                : !editData[0].isCheckManualDisProduct
                ? this.setDestinationProduct()
                : this.addTransportLegProduct();
            });
        }
      );

    this.subscriptionCheckDeleteRowData =
      this.projectScenarioFillingDataGridService.checkDeleteRowFillData$.subscribe((check: any) => {
        this.scenarioAddEditForm.controls['origin'].setValue(null);
        this.scenarioAddEditForm.controls['destination'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForLocation'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForDistance'].setValue(null);
        this.scenarioAddEditForm.controls['distance'].setValue('');
        this.isCheckUpdateDestination = false;
        this.isCheckUpdateOrigin = false;
        this.isCheckEditManudalDist = false;
        check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
      });

    this.subscriptionCheckDeleteRowDataProduct =
      this.projectScenarioFillingDataGridService.checkDeleteRowFillDataProduct$.subscribe(
        (check: any) => {
          this.scenarioAddEditForm.controls['originProduct'].setValue(null);
          this.scenarioAddEditForm.controls['destinationProduct'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForLocationProduct'].setValue(null);
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].setValue(null);
          this.scenarioAddEditForm.controls['distanceProduct'].setValue('');
          this.isCheckUpdateDestinationProduct = false;
          this.isCheckUpdateOriginProduct = false;
          this.isCheckEditManudalDistProduct = false;
          check[2] &&
            check[0].length > 0 &&
            this.deleteSetDistanceRecordProduct(check[0], check[1]);
        }
      );

    this.subscriptionProjectFillData =
      this.projectScenarioFillingDataGridService.editProjectFillSubData$.subscribe(
        async (editData: any) => {
          this.projectFilleditData = editData[0];
          this.isCustomTruck = editData[0].isCustomTruck;
          this.transportModeId = editData[0].transportModeId;
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.scenarioAddEditForm.controls['distanceManulaLocation'].setValue(
            distanceManualLocationvalue
          );
          if (editData[0].isCheckManualDis) {
            this.isCheckEditManudalDist = true;
            this.isCustomTruck = editData[0].isCustomTruck;
            this.scenarioAddEditForm.controls['distance'].setValue(editData[0].distance);
          }
          this.transportModeList = this.isCustomTruck
            ? this.customTransportModeList
            : this.fillingData.transportModeItems;
          if (editData[1]) {
            this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
              this.checkIsOrginBtn = data.length <= 1 ? true : false;
            });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].location;
            editData[0].idStr = editData[0].originId;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.customTransportModeList
              : this.fillingData.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                if (editData[0].isCheckManualDis) {
                  this.scenarioAddEditForm.patchValue({
                    transportModeForDistance: this.setDestinationLocationData,
                  });
                } else {
                  this.scenarioAddEditForm.patchValue({
                    transportModeForLocation: this.setDestinationLocationData,
                  });
                }
              }
            });
          }
        }
      );

    this.subscriptionProjectFillDataProduct =
      this.projectScenarioFillingDataGridService.editProjectFillSubProductData$.subscribe(
        async (editData: any) => {
          this.projectFilleditDataProduct = editData[0];
          this.isCustomTruckProduct = editData[0].isCustomTruck;
          this.transportModeIdProduct = editData[0].transportModeId;
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.scenarioAddEditForm.controls['distanceManulaLocationProduct'].setValue(
            distanceManualLocationvalue
          );
          if (editData[0].isCheckManualDisProduct) {
            this.isCheckEditManudalDistProduct = true;
            this.isCustomTruckProduct = editData[0].isCustomTruck;
            this.scenarioAddEditForm.controls['distanceProduct'].setValue(editData[0].distance);
          }
          this.transportModeListProduct = !!this.isCustomTruckProduct
            ? this.customTransportModeList
            : this.fillingData.transportModeItems;
          if (editData[1]) {
            this.projectFacade.locationProcessProductData$
              .pipe(take(1))
              .subscribe(async (data: any) => {
                this.checkIsOrginBtnProduct = data.length <= 1 ? true : false;
              });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].originName;
            editData[0].idStr = editData[0].originId;
            await this.fingOriginAndDestinationProduct(editData[0]);
            this.getLastItemProduct();
            const location = editData[0].isCustomTruck
              ? this.customTransportModeList
              : this.fillingData.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationDataProduct = x;
                if (editData[0].isCheckManualDisProduct) {
                  this.scenarioAddEditForm.patchValue({
                    transportModeForDistanceProduct: this.setDestinationLocationDataProduct,
                  });
                } else {
                  this.scenarioAddEditForm.patchValue({
                    transportModeForLocationProduct: this.setDestinationLocationDataProduct,
                  });
                }
              }
            });
          }
        }
      );

    this.scenarioAddEditForm = this.formBuilder.group({
      component: [null, Validators.required],
      process: [null, Validators.required],
      amount: [null, [Validators.required, nonNegativeValidator]],
      location: [null, Validators.required],
      costPerUnit: [null, [Validators.required, nonNegativeValidator]],
      costPerPackage: [{ value: null, disabled: true }, Validators.required],
      origin: [null],
      originProduct: [null],
      customFreight: [null],
      customFreightProduct: [null],
      destination: [null],
      destinationProduct: [null],
      distance: [null],
      distanceProduct: [null],
      distanceManulaLocation: [''],
      distanceManulaLocationProduct: [''],
      transportModeForLocation: [null],
      transportModeForLocationProduct: [null],
      transportModeForDistance: [null],
      transportModeForDistanceProduct: [null],
      productPercentageLoss: [
        this.fillingData.percentageProductLoss,
        [nonNegativeValidator, Validators.max(100)],
      ],
      productLoss: [null],
      secondaryMarket: [
        this.fillingData?.percentageOfReusedProduct &&
        this.fillingData?.percentageOfReusedProduct != 0
          ? this.fillingData?.percentageOfReusedProduct
          : this.secondaryDefaultValue,
      ],
      product: [null],
    });
    this.setProductLoss();
    !!this.productCustomTransportScenarioId && this.getCustomFreight();

    this.scenarioAddEditForm.controls['product'].valueChanges.subscribe(value => {
      this.isProductEmpty = !value || value.length === 0;
    });
    this.scenarioAddEditForm.controls['component'].valueChanges.subscribe(value => {
      this.isComponentEmpty = !value || value.length === 0;
    });
  }

  getCustomFreight() {
    this.fillingData?.customtransportScenarioItems.find((x: any) => {
      if (this.productCustomTransportScenarioId == x.id) {
        this.customFreightSelectDataProduct = x;
        this.scenarioAddEditForm.patchValue({ customFreightProduct: x });
      }
    });
  }

  editFillingDistance(record: any) {
    this.projectFacade.fillingTransportProcess(record[1], 'edit');
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  editFillingDistanceProduct(record: any) {
    this.projectFacade.locationProductProcessActions(record[1], 'edit');
  }

  productLossFilling(event: any) {
    if (event.target.value > 0) {
      this.scenarioAddEditForm.controls['productLoss'].setValidators([
        Validators.required,
        nonNegativeValidator,
      ]);
      this.scenarioAddEditForm.controls['productLoss'].updateValueAndValidity();
    } else {
      this.scenarioAddEditForm.controls['productLoss'].removeValidators([
        Validators.required,
        nonNegativeValidator,
      ]);
      this.scenarioAddEditForm.controls['productLoss'].updateValueAndValidity();
    }
  }

  selectedProduct(event: any) {
    this.productId = Number(event.idStr);
    this.projectFacade.clearFillDataProductErr();
  }

  customTruckProduct(event: any) {
    this.isCustomTruckProduct = event.target.checked ? true : false;
    this.transportProductColumnDefs =
      this.projectScenarioFillingDataGridService.locationColumnProduct();
    this.transportProductColumnDefs.forEach((column: any) => {
      if (this.isCustomTruckProduct && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruckProduct && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProductColumnDefs = cloneDeep(this.transportProductColumnDefs);
    this.distanceProductColumnDefs = this.distanceProductColumnDefs.splice(1);
    this.distanceProductColumnDefs.forEach((column: any) => {
      if (this.isCustomTruckProduct && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruckProduct && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.percenteageMassLoadProd = 0;
    this.transportModeListProduct = !!this.isCustomTruckProduct
      ? this.customTransportModeList
      : this.fillingData.transportModeItems;
    this.scenarioAddEditForm.controls['transportModeForLocationProduct'].setValue(null);
    this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].setValue(null);
  }

  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.transportColumnDefs = this.projectScenarioFillingDataGridService.locationColumn();
    this.transportColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs);
    this.distanceColumnDefs = this.distanceColumnDefs.splice(1);
    this.distanceColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.scenarioAddEditForm.controls['origin'].setValue(null);
        this.scenarioAddEditForm.controls['destination'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForLocation'].reset();
        this.transportaionId = 2;
        this.customTransportList = null;
        this.transportModeList = this.fillingData.transportModeItems;
        this.showDropdownFreight = false;
        this.percenteageMassLoad = 0;
        this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.locationProcessActions(updatedData, 'reset');
          }
        });
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.scenarioAddEditForm.controls['origin'].setValue(null);
        this.scenarioAddEditForm.controls['destination'].setValue(null);
        this.scenarioAddEditForm.controls['distance'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForDistance'].reset();
        this.scenarioAddEditForm.controls['distanceManulaLocation'].setValue(null);
        this.location = null;
        this.transportaionId = 3;
        this.transportModeList = this.fillingData.transportModeItems;
        this.showDropdownFreight = false;
        this.percenteageMassLoad = 0;
        this.projectFacade.distanceProcessData$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.distanceTransportActions(updatedData, 'reset');
          }
        });
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.isShowDistantField = false;
        this.scenarioAddEditForm.controls['origin'].setValue(null);
        this.scenarioAddEditForm.controls['destination'].setValue(null);
        this.scenarioAddEditForm.controls['distanceManulaLocation'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForLocation'].reset();
        this.location = null;
        this.percenteageMassLoad = 0;
        this.transportaionId = 4;
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }

  manualLocationProduct(data: any) {
    this.selectLocationProduct = false;
    this.selectDistanceProduct = false;
    this.selectCustomProduct = false;
    this.isCheckEditManudalDistProduct = false;
    this.isCheckUpdateOriginProduct = false;
    this.isCheckUpdateDestinationProduct = false;
    this.isCustomTruckProduct = false;
    this.transportProductColumnDefs =
      this.projectScenarioFillingDataGridService.locationColumnProduct();
    this.transportProductColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProductColumnDefs = cloneDeep(this.transportProductColumnDefs);
    this.distanceProductColumnDefs = this.distanceProductColumnDefs.splice(1);
    this.distanceProductColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.wholeDataProduct[0]['img'] = this.locationBlack;
    this.wholeDataProduct[1]['img'] = this.distanceBlack;
    this.wholeDataProduct[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeDataProduct[0]['img'] = this.loactionWhite;
        this.selectedProductBox.id = 2;
        this.selectLocationProduct = true;
        this.isShowCustomTransportList = false;
        this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].setValue(null);
        this.scenarioAddEditForm.controls['distanceProduct'].reset();
        this.scenarioAddEditForm.controls['transportModeForLocationProduct'].reset();
        this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].reset();
        this.scenarioAddEditForm.controls['distanceManulaLocationProduct'].setValue('');
        this.productTransportaionId = 2;
        this.customTransportList = null;
        this.transportModeListProduct = this.fillingData.transportModeItems;
        this.percenteageMassLoadProd = 0;
        this.projectFacade.locationProcessProductData$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.locationProductProcessActions(updatedData, 'reset');
          }
        });
        break;
      case 'distance':
        this.wholeDataProduct[1]['img'] = this.distanceWhite;
        this.selectedProductBox.id = 3;
        this.selectDistanceProduct = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.scenarioAddEditForm.controls['originProduct'].setValue(null);
        this.scenarioAddEditForm.controls['destinationProduct'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForLocationProduct'].setValue(null);
        this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].setValue(null);
        this.scenarioAddEditForm.controls['distanceManulaLocationProduct'].setValue('');
        this.transportModeListProduct = this.fillingData.transportModeItems;
        this.location = null;
        this.productTransportaionId = 3;
        this.percenteageMassLoadProd = 0;
        this.projectFacade.distanceProcessProductData$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.distanceTransportProductActions(updatedData, 'reset');
          }
        });
        break;
      case 'custom':
        this.wholeDataProduct[2]['img'] = this.customWhite;
        this.selectedProductBox.id = 4;
        this.selectCustomProduct = true;
        this.isShowDistantField = false;
        this.scenarioAddEditForm.controls['originProduct'].setValue(null);
        this.scenarioAddEditForm.controls['destinationProduct'].setValue(null);
        this.scenarioAddEditForm.controls['distanceProduct'].reset();
        this.scenarioAddEditForm.controls['transportModeForLocationProduct'].reset();
        this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].reset();
        this.location = null;
        this.productTransportaionId = 4;
        this.percenteageMassLoadProd = 0;
        this.addCustomFreightProduct();
        break;
      default:
        break;
    }
  }

  async calcCost() {
    const amt = this.scenarioAddEditForm.controls['amount'].value;
    const costPerUnit = this.scenarioAddEditForm.controls['costPerUnit'].value;
    const costPerPackageValue = amt * (costPerUnit / 1000);
    this.scenarioAddEditForm.controls['costPerPackage'].setValue(costPerPackageValue);
  }

  async setProductLoss() {
    await this.productLossList.map((item: any) => {
      if (item.id == this.fillingData.productlossId) {
        return (this.selectedProductLoss = item);
      }
    });
    this.setValue();
  }

  async setCountry() {
    await this.countryList.map((item: any) => {
      if (item.id == this.fillingData.fillingProcessCountryId) {
        this.selectedCountry = item;
      }
    });
  }

  async setProductItem() {
    await this.fillingData?.productListItems?.map((item: any) => {
      if (item.idStr == this.fillingData?.productId) {
        this.selectedProductItem = item;
      }
    });
  }

  setValue() {
    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectLocation = true;
        break;
      case 3:
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectDistance = true;
        break;
      case 4:
        this.wholeData[2]['img'] = this.customWhite;
        this.selectCustom = true;
        break;
      default:
        break;
    }
    switch (this.selectedProductBox?.id) {
      case 2:
        this.wholeDataProduct[0]['img'] = this.loactionWhite;
        this.selectLocationProduct = true;
        break;
      case 3:
        this.wholeDataProduct[1]['img'] = this.distanceWhite;
        this.selectDistanceProduct = true;
        break;
      case 4:
        this.wholeDataProduct[2]['img'] = this.customWhite;
        this.selectCustomProduct = true;
        break;
      default:
        break;
    }
    this.secondaryMarketDropdown =
      this.selectedProductLoss?.name == this.secondaryMarketStr ? true : false;
    this.scenarioAddEditForm.patchValue({
      productLoss: this.selectedProductLoss,
      location: this.selectedCountry,
    });
  }

  changeProductLoss(event: any, type: 'clear' | 'change') {
    if (type == 'change' && event?.id) {
      this.secondaryMarketDropdown = event.name == this.secondaryMarketStr ? true : false;
    } else {
      this.secondaryMarketDropdown = false;
    }
  }

  selectFreight(event: any) {
    this.projectFacade.clearFreightProcess();
    if (event?.id) {
      this.customFreightSelectData = event;
    }
  }

  resetTransport() {
    this.customFreightSelectData = null;
  }
  addCustomFreight() {
    if (!!this.customFreightSelectData) {
      this.projectFacade.customFreightActions(
        this.customFreightSelectData.id,
        this.customFreightSelectData.isCustomSiteTransport
      );
    }
  }
  selectFreightProduct(event: any) {
    this.projectFacade.clearFreightProcessProduct();
    if (event?.id) {
      this.customFreightSelectDataProduct = event;
    }
  }

  resetTransportProduct() {
    this.customFreightSelectDataProduct = null;
  }

  addCustomFreightProduct() {
    if (!!this.customFreightSelectDataProduct) {
      this.customScenarioId = this.customFreightSelectDataProduct.id; // For freight of product
      this.projectFacade.customFreightProductActions(
        this.customFreightSelectDataProduct.id,
        this.customFreightSelectDataProduct.isCustomSiteTransport
      );
    }
  }

  getLastItem() {
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((data: any) => {
      this.lastItem = this.isCheckUpdateDestination
        ? data[data.findIndex((item: any) => item.index === this.projectFilleditData.index) - 1]
        : data[data?.length - 1];
    });
  }

  changeTransportMode(event: any, type?: any) {
    if (event?.id || event?.idStr || event?.truckId) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
    }
    if (event?.id || event?.idStr || (event?.truckId && this.isCustomTruck)) {
      this.getMassLoad(event, 'def');
    }
  }

  getMassLoad(event: any, from?: any) {
    if (event.id) {
      this.projectsService.getTruckMassLoad(event.id || event.truckId).subscribe((res: any) => {
        if (from == 'def') {
          this.percenteageMassLoad = res.data.percenteageMassLoad;
        } else {
          this.percenteageMassLoadProd = res.data.percenteageMassLoad;
        }
      });
    }
  }
  getLastItemProduct() {
    this.projectFacade.locationProcessProductData$.pipe(take(1)).subscribe((data: any) => {
      this.lastItemProduct = this.isCheckUpdateDestinationProduct
        ? data[
            data.findIndex((item: any) => item.index === this.projectFilleditDataProduct.index) - 1
          ]
        : data[data?.length - 1];
    });
  }
  changeTransportModeProduct(event: any, type?: any) {
    if (event?.id || event?.idStr || event?.truckId) {
      this.transportModeIdProduct = event.id;
      this.transportModeNameProduct = event.name;
      this.transportModeDescriptionProduct = event.description;
      this.getLastItemProduct();
    }
    if ((event?.id || event?.idStr || event?.truckId) && this.isCustomTruckProduct) {
      this.getMassLoad(event, 'prod');
    }
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.transportFreightModeList = res.data;
    });
  }

  async calculateDistance(lastItem?: any) {
    const payload = {
      origin: lastItem.location,
      destination: this.scenarioAddEditForm.controls['destination'].value.name,
      destinationId: Number(this.scenarioAddEditForm.controls['destination'].value.idStr),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.location,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.scenarioAddEditForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis(lastItem, true);
    }
  }

  async getCalculateDis(lastItem: any, checkType: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem?.location || lastItem?.originName],
      destinations: [
        this.scenarioAddEditForm.controls[checkType ? 'destination' : 'destinationProduct'].value
          .name,
      ],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.scenarioAddEditForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  async calculateDistanceProduct(lastItem?: any) {
    const payload = {
      origin: lastItem?.location || lastItem?.originName,
      destination: this.scenarioAddEditForm.controls['destinationProduct'].value.name,
      destinationId: Number(this.scenarioAddEditForm.controls['destinationProduct'].value.idStr),
      iscustomtruck: this.isCustomTruckProduct,
      transportmodeId: this.transportModeIdProduct,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem?.location || lastItem?.originName,
          transportModeName: this.transportModeNameProduct,
          customTransportScenarioId: 0,
          imageName: lastItem?.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.scenarioAddEditForm.controls['distanceProduct'].setValue(response?.data.distance);
      this.setManualLocationDis = response?.data.distance;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis(lastItem, false);
    }
  }

  changeCustomTruck(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.percenteageMassLoad = 0;
    this.transportColumnDefs = this.projectScenarioFillingDataGridService.locationColumn();
    this.transportColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs);
    this.distanceColumnDefs = this.distanceColumnDefs.splice(1);
    this.distanceColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportModeList = !!this.isCustomTruck
      ? this.customTransportModeList
      : this.fillingData.transportModeItems;
    this.scenarioAddEditForm.controls['transportModeForLocation'].reset();
  }

  changeCustomTruckDistance(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.transportColumnDefs = this.projectScenarioFillingDataGridService.locationColumn();
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs).splice(1);
    this.distanceColumnDefs[2].editable = false;
    this.distanceColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.percenteageMassLoad = 0;
    this.transportModeList = !!this.isCustomTruck
      ? this.customTransportModeList
      : this.fillingData.transportModeItems;
    this.scenarioAddEditForm.controls['transportModeForDistance'].reset();
  }

  toggleCustomFilling(eve: any) {
    this.isProductContent = !!eve.target.checked ? true : false;
    if (!!this.isProductContent) {
      this.scenarioAddEditForm.controls['process'].setValue(this.selectedCustomFillingItem);
      this.fillingProcess = this.fillingData.fillingListiItems;
    } else {
      this.scenarioAddEditForm.controls['process'].setValue(this.selectedEnergyItem);
      this.fillingProcess = this.fillingData.energyProcessItems;
    }
  }

  selectChange(eve: any) {
    if (eve?.id || eve.idStr) {
      if (!!this.isProductContent) {
        this.selectedCustomFillingItem = eve;
      } else {
        this.selectedEnergyItem = eve;
      }
    }
  }

  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }

  onChangeSearch(searchValue: string, type: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    if (type === 'origin' || type === 'destination') {
      this.keywordAuto = this.keywordAuto?.trimStart();
      if (this.keywordAuto.length) {
        this.isLoading = true;
        this.pageNumber = 1;
        this.searchValue = this.keywordAuto;
        this.selectedCities = [];
        this.searchSubject.next(this.keywordAuto);
      }
    } else if (type == 'originProduct' || type == 'destinationProduct') {
      this.keywordAuto = this.keywordAuto?.trimStart();
      if (this.keywordAuto.length) {
        this.isLoadingProduct = true;
        this.pageNumberProduct = 1;
        this.searchValueProduct = this.keywordAuto;
        this.selectedCitiesProduct = [];
        this.searchSubjectProduct.next(this.keywordAuto);
      }
    }
  }

  onScroll(type: string) {
    if (type === 'origin' || type === 'destination') {
      if (this.selectedCities?.length < 50) return;
      this.pageNumber++;
      this.isLoading = true;
      this.searchCities(this.searchValue);
    } else {
      if (this.selectedCitiesProduct?.length < 50) return;
      this.pageNumberProduct++;
      this.isLoadingProduct = true;
      this.searchCitiesProduct(this.searchValueProduct);
    }
  }
  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  async searchCitiesProduct(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumberProduct,
      searchValue,
      this.isShowPortProduct
    );
    this.selectedCitiesProduct =
      this.pageNumberProduct === 1 ? res.data : [...this.selectedCitiesProduct, ...res.data];
    this.autoForOriginProduct?.focus();
    this.autoForDestinationProduct?.focus();
    this.isLoadingProduct = false;
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  onClearSearchProduct(event: any) {
    this.isLoadingProduct = false;
    this.selectedCitiesProduct = [];
    this.pageNumberProduct = 1;
    this.searchValueProduct = '';
    this.autoForOriginProduct?.close();
    this.autoForDestinationProduct?.close();
  }

  selectEvent(event: any) {
    this.cityId = event.idStr;
    this.location = event.name;
    this.disableDestination = false;
    this.disableOrigin = false;
    this.disableOriginProduct = false;
    this.disableDestinationProduct = false;
    this.keywordAuto = '';
    this.selectedCities = [];
    this.selectedCitiesProduct = [];
  }

  showPorts(event: any) {
    this.scenarioAddEditForm.controls['origin'].setValue(null);
    this.scenarioAddEditForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  showPortsProduct(event: any) {
    this.scenarioAddEditForm.controls['originProduct'].setValue(null);
    this.scenarioAddEditForm.controls['destinationProduct'].setValue(null);
    this.isShowPortProduct = event.target.checked;
  }

  restrictE(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  onClose() {
    this.modal.close();
    this.projectFacade.clearFillingProcess();
    this.projectFacade.clearDistanceProcess();
    this.projectFacade.clearFreightProcess();
    this.projectFacade.clearLocationProcess();
    this.projectFacade.clearLocationProcessProduct();
    this.projectFacade.clearDistanceProcessProduct();
    this.projectFacade.clearFreightProcessProduct();
    this.projectFacade.clearFillDataComponentErr();
    this.projectFacade.clearFillDataProductErr();
    this.location = null;
  }

  changeLocation(data: any, list: any) {
    if (data?.id && list.length) {
      this.selectedCountry = data;
      this.projectFacade.fillingProcessActions({ id: data.id, name: data.name }, 'edit');
    }
  }

  addFillingProcess() {
    this.fillingSubmitted = true;
    if (
      !this.fillingData?.isCostTrunOff &&
      !this.isProductContent &&
      this.scenarioAddEditForm.controls['costPerUnit'].invalid
    ) {
      return;
    }
    if (
      ((!this.isProductContent &&
        this.scenarioAddEditForm.controls['amount'].valid &&
        this.scenarioAddEditForm.controls['location'].valid) ||
        this.isProductContent) &&
      this.scenarioAddEditForm.controls['process'].valid
    ) {
      const payload = {
        fillingProcessName: this.scenarioAddEditForm.controls['process'].value?.name,
        amount: this.scenarioAddEditForm.controls['amount'].value,
        costPerUnit: this.scenarioAddEditForm.controls['costPerUnit'].value,
        costPerPackage: this.scenarioAddEditForm.controls['costPerPackage'].value,
        countryName: this.scenarioAddEditForm.controls['location'].value?.name,
        energyProcessId: this.selectedEnergyItem?.id,
        customFillingId:
          this.selectedCustomFillingItem?.idStr || this.selectedCustomFillingItem?.id,
        countryId:
          this.scenarioAddEditForm.controls['location'].value?.id ||
          this.scenarioAddEditForm.controls['location'].value,
        isCustomFilling: this.isProductContent,
      };
      this.fillingSubmitted = false;
      this.projectFacade.fillingProcessActions(payload, 'add');
      this.scenarioAddEditForm.controls['amount'].reset();
      this.scenarioAddEditForm.controls['process'].reset();
      this.scenarioAddEditForm.controls['costPerUnit'].reset();
      this.scenarioAddEditForm.controls['costPerPackage'].reset();
    }
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.location],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
      const startIndex = data.findIndex(
        (item: any) => item.index === this.projectFilleditData.index
      ); // Index to start checking after
      if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
        let destinationNextRecord =
          data[data.findIndex((item: any) => item.index === this.projectFilleditData.index) + 1];
        const lastItemNextRecord = this.scenarioAddEditForm.value.destination;
        try {
          await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
          Object.freeze(destinationNextRecord);
          const objCopy = { ...destinationNextRecord };
          objCopy.distance = this.setManualLocationDisForNextRecord;
          destinationNextRecord = objCopy;
          this.projectFacade.locationProcessActions(destinationNextRecord, 'edit');
        } catch (error) {
          // Handle error, e.g., log it or show a user-friendly message.
          console.error('Error:', error);
        }
      }
    });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacade.locationProcessData$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (!!belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.location, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacade.locationProcessActions(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.location;
      const toCity = this.scenarioAddEditForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.scenarioAddEditForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.scenarioAddEditForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }
  seaDistanceMatrixProduct(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem?.location || lastItem?.originName;
      const toCity = this.scenarioAddEditForm.controls['destinationProduct'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.scenarioAddEditForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.scenarioAddEditForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistanceProduct = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async setDestination() {
    // For setting Destination
    this.setDestinationsubmitted = true;
    if (
      !this.scenarioAddEditForm.controls['destination']?.value?.hasOwnProperty('name') &&
      this.scenarioAddEditForm.controls['destination'].value != null
    ) {
      this.disableDestination = true;
    } else if (
      !!this.scenarioAddEditForm.controls['transportModeForLocation'].value &&
      !!this.scenarioAddEditForm.controls['destination'].value &&
      this.scenarioAddEditForm.controls['destination']?.value?.hasOwnProperty('name')
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.scenarioAddEditForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        (this.scenarioAddEditForm.controls['destination']?.value?.name?.includes('Port') &&
          (this.lastItem?.location?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        !!this.transportModeId && (await this.calculateDistance(this.lastItem));
      }
      if (this.messageType != 1) {
        if (
          (this.scenarioAddEditForm.value.destination?.idStr ||
            this.scenarioAddEditForm.value.destination?.originId) ==
            this.projectFilleditData?.originId &&
          this.transportModeId == this.projectFilleditData?.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.projectFilleditData?.originId &&
          this.scenarioAddEditForm.value.destination.idStr != this.projectFilleditData?.originId &&
          this.changeNextRecordDistance();
        this.disableDestination = false;
        const payload: any = {
          location: this.scenarioAddEditForm.controls['destination'].value.name,
          persanteageMassLoad: this.percenteageMassLoad || 0,
          transportModeName:
            this.scenarioAddEditForm.controls['transportModeForLocation'].value?.name,
          transportModeId: this.scenarioAddEditForm.controls['transportModeForLocation'].value?.id,
          customTruckId: !!this.transportModeId
            ? this.transportModeId
            : this.projectFilleditData.transportModeId,
          description: this.isCustomTruck
            ? 'Truck.png'
            : this.scenarioAddEditForm.controls['transportModeForLocation'].value?.description,
          transportaionId: this.transportaionId,
          originId:
            this.scenarioAddEditForm.controls['destination']?.value?.idStr ||
            this.scenarioAddEditForm.controls['destination']?.value?.originId,
          id: this.fillingData.id,
          isCustomTruck: this.isCustomTruck,
        };
        if (this.isCheckUpdateDestination) {
          payload['index'] = this.projectFilleditData?.index;
        }
        const newManualLocationDisatance =
          this.scenarioAddEditForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.projectFilleditData?.distance == 'string' &&
          !!this.projectFilleditData?.distance
            ? this.projectFilleditData?.distance?.substring(
                this.projectFilleditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);
        if (this.transportModeName?.toLowerCase() == commonEnum.shipName) {
          payload['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          payload['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }

        payload['isCheckManualDis'] = false;
        this.projectFacade.locationProcessActions(
          payload,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.setDestinationsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.projectFilleditData = null;
        this.scenarioAddEditForm.controls['destination'].reset();
        this.scenarioAddEditForm.controls['transportModeForLocation'].reset();
        this.location = null;
        this.messageType = 0;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.scenarioAddEditForm.controls['transportModeForLocation'].reset();
        this.setDestinationsubmitted = false;
        this.messageType = 0;
      } else {
        this.setDestinationsubmitted = true;
      }
    }
  }

  refreshTruckList() {
    this.projectsService.getCustomTruckList().subscribe((res: any) => {
      this.customTransportModeList = res.data;
      this.transportModeList = this.isCustomTruck
        ? this.customTransportModeList
        : this.fillingData.transportModeItems;
      this.transportModeListProduct = this.isCustomTruckProduct
        ? this.customTransportModeList
        : this.fillingData.transportModeItems;
    });
  }

  refreshFillingList() {
    this.customService.getCustomFillingList().subscribe((res: any) => {
      this.fillingProcess = res.data.map((x: any) => {
        return { ...x, name: x.processName };
      });
    });
  }

  addComponentTransport(data: any, distanceData: any, customData: any) {
    this.componentSubmitted = true;
    if (this.scenarioAddEditForm.controls['component'].invalid) {
      this.projectFacade.clearFillDataComponentErr();
      return;
    } else {
      if (this.selectLocation) {
        data = data;
        distanceData = [];
        customData = [];
      } else if (this.selectDistance) {
        distanceData = distanceData;
        data = [];
        customData = [];
      } else {
        data = [];
        distanceData = [];
        customData = customData;
      }
      let dataList;
      data = data.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        } else {
          Object.freeze(item);
          const objCopy = { ...item };
          objCopy.unit = 'km';
          item = objCopy;
        }
        return item;
      });

      if (!!distanceData) {
        distanceData = distanceData.map((item: any) => {
          return {
            ...item,
            unit: 'km',
          };
        });
      }
      dataList =
        data.length > 0
          ? data
          : distanceData.length > 0
          ? distanceData
          : customData.length > 0
          ? customData
          : [];
      this.dataListHolder = dataList;
      this.transportIcons = dataList.map((ele: any, index: any, arr: any) => {
        return {
          ...arr[index],
          imageName: arr[index]?.description || arr[index]?.transportModeImage,
          cityName: arr[index]?.location,
        };
      });
      this.scenarioAddEditForm.controls['component'].value.forEach((ele: any, i: any) => {
        const payload: any = {};
        payload['componentName'] = this.scenarioAddEditForm.controls['component'].value[i]?.name;
        payload['transportIcons'] = this.transportIcons;
        payload['componentId'] = this.scenarioAddEditForm.controls['component'].value[i]?.idStr;
        payload['transportaionId'] = this.transportaionId;
        payload['locationTransportationItems'] = data.map((item: any, index: number) => {
          return {
            ...item,
            parentOrder: this.parentOrderComponent,
            childOrder: index + 1,
            imageName: item.description || item.transportModeImage,
            cityName: item.location,
          };
        });
        payload['distanceTransportationItems'] = distanceData.map((item: any, index: number) => {
          return {
            ...item,
            imageName: item.description,
            parentOrder: this.parentOrderComponent,
            childOrder: index + 1,
            unit: 'km',
          };
        });
        payload['customTransportScenarioId'] =
          this.scenarioAddEditForm.controls['customFreight'].value?.id;
        this.parentOrderComponent = this.parentOrderComponent + 1;
        this.projectFacade.componentTransportActions(payload, 'add');
      });
      this.projectFacade.clearFreightProcess();
      this.projectFacade.clearDistanceProcess();
      this.projectFacade.clearLocationProcess();
      this.scenarioAddEditForm.controls['customFreight'].reset();
      this.scenarioAddEditForm.controls['origin'].reset();
      this.showDropdownFreight = false;
      this.scenarioAddEditForm.controls['component'].reset();
      this.componentSubmitted = false;
      this.customFreightSelectData = null;
    }
    this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
  }

  addProductTransport(data: any, distanceData: any, customData: any) {
    this.productSubmitted = true;
    this.scenarioAddEditForm.controls['product'].setValidators([Validators.required]);
    this.scenarioAddEditForm.controls['product'].updateValueAndValidity();
    this.projectFacade.clearFillDataProductErr();
    if (this.scenarioAddEditForm.controls['product'].invalid) {
      return;
    } else {
      if (this.selectLocationProduct) {
        data = data;
        distanceData = [];
        customData = [];
      } else if (this.selectDistanceProduct) {
        distanceData = distanceData;
        data = [];
        customData = [];
      } else {
        data = [];
        distanceData = [];
        customData = customData;
      }
      let dataList;
      data = data.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        } else {
          Object.freeze(item);
          const objCopy = { ...item };
          objCopy.unit = 'km';
          item = objCopy;
        }
        return item;
      });

      if (!!distanceData) {
        distanceData = distanceData.map((item: any) => {
          return {
            ...item,
            unit: 'km',
          };
        });
      }
      dataList =
        data.length > 0
          ? data
          : distanceData.length > 0
          ? distanceData
          : customData.length > 0
          ? customData
          : [];
      this.transportProductIcons = dataList.map((ele: any, index: any, arr: any) => {
        return {
          ...arr[index],
          imageName: arr[index]?.description || arr[index]?.transportModeImage,
          cityName: arr[index]?.originName,
        };
      });
      this.scenarioAddEditForm.controls['product'].value.forEach((ele: any, i: any) => {
        const payload: any = {};
        payload['productName'] = this.scenarioAddEditForm.controls['product'].value[i]?.name;
        payload['transportIcons'] = this.transportProductIcons;
        payload['productId'] = this.scenarioAddEditForm.controls['product'].value[i]?.idStr;
        payload['productTransportaionId'] = this.productTransportaionId;
        payload['productLocationTransportationItems'] = data.map((item: any, index: number) => {
          return {
            ...item,
            parentOrder: this.parentOrder,
            childOrder: index + 1,
          };
        });
        payload['productDistanceTransportationItems'] = distanceData.map(
          (item: any, index: number) => {
            return {
              ...item,
              imageName: item.description,
              parentOrder: this.parentOrder,
              childOrder: index + 1,
              unit: 'km',
            };
          }
        );
        payload['productCustomTransportScenarioId'] =
          this.scenarioAddEditForm.controls['customFreightProduct'].value?.id;
        this.parentOrder = this.parentOrder + 1;
        this.projectFacade.productTransportActions(payload, 'add');
      });

      this.projectFacade.clearFreightProcessProduct();
      this.projectFacade.clearDistanceProcessProduct();
      this.projectFacade.clearLocationProcessProduct();
      this.scenarioAddEditForm.controls['customFreightProduct'].reset();
      this.scenarioAddEditForm.controls['originProduct'].reset();
      this.showDropdownFreight = false;
      this.scenarioAddEditForm.controls['product'].reset();
      this.scenarioAddEditForm.controls['product'].clearValidators();
      this.scenarioAddEditForm.controls['product'].updateValueAndValidity();
      this.productSubmitted = false;
      this.customFreightSelectData = null;
    }
    // this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
  }

  selectedComponents(eve: any) {
    this.componentIds = eve;
    this.projectFacade.clearFillDataComponentErr();
  }

  addTransportLeg() {
    this.transportModeErrDistance = true;
    if (
      !!this.scenarioAddEditForm.controls['transportModeForDistance'].value &&
      !!this.scenarioAddEditForm.controls['distance'].value
    ) {
      const isDistance = true;
      this.transportModeErrDistance = false;
      const payload: any = {
        transportModeName:
          this.scenarioAddEditForm.controls['transportModeForDistance'].value?.name,
        transportModeId: this.scenarioAddEditForm.controls['transportModeForDistance'].value?.id,
        persanteageMassLoad: this.percenteageMassLoad || 0,
        distance: this.scenarioAddEditForm.controls['distance'].value,
        customTruckId: this.scenarioAddEditForm.controls['transportModeForDistance'].value?.id,
        isCustomTruck: this.isCustomTruck,
        transportaionId: this.transportaionId,
        description: this.isCustomTruck
          ? 'Truck.png'
          : this.scenarioAddEditForm.controls['transportModeForDistance'].value?.description,
      };
      if (this.isCheckEditManudalDist) {
        payload['index'] = this.projectFilleditData.index;
      }
      payload['isCheckManualDis'] = true;
      this.projectFacade.distanceTransportActions(
        payload,
        this.isCheckEditManudalDist ? 'edit' : 'add',
        isDistance
      );
      this.isCheckEditManudalDist = false;
      this.projectFilleditData = null;
      this.scenarioAddEditForm.controls['distance'].reset();
      this.scenarioAddEditForm.controls['transportModeForDistance'].reset();
    }
  }

  addTransportLegProduct() {
    this.transportModeErrDistanceProd = true;
    if (
      !!this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].value &&
      !!this.scenarioAddEditForm.controls['distanceProduct'].value
    ) {
      const isDistance = true;
      this.transportModeErrDistanceProd = false;
      const payload: any = {
        transportModeName:
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].value?.name,
        productTransportaionId: this.productTransportaionId,
        transportModeId:
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].value?.id,
        persanteageMassLoad: this.percenteageMassLoadProd || 0,
        distance: this.scenarioAddEditForm.controls['distanceProduct'].value,
        customTruckId:
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].value?.id,
        isCustomTruck: this.isCustomTruckProduct,
        description:
          this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].value?.description,
      };
      if (this.isCheckEditManudalDistProduct) {
        payload['index'] = this.projectFilleditDataProduct.index;
      }
      payload['isCheckManualDisProduct'] = true;
      this.projectFacade.distanceTransportProductActions(
        payload,
        this.isCheckEditManudalDistProduct ? 'edit' : 'add',
        isDistance
      );
      this.isCheckEditManudalDistProduct = false;
      this.projectFilleditDataProduct = null;
      this.scenarioAddEditForm.controls['distanceProduct'].reset();
      this.scenarioAddEditForm.controls['transportModeForDistanceProduct'].reset();
    }
  }

  setLocation() {
    // For setting Origin
    this.setOriginsubmitted = true;
    if (!this.scenarioAddEditForm.controls['origin']?.value?.hasOwnProperty('name')) {
      this.disableOrigin = true;
    } else if (!!this.scenarioAddEditForm.controls['origin'].value) {
      this.disableOrigin = false;
      const payload = {
        location: !!this.location ? this.location : this.projectFilleditData.originName,
        originId: this.cityId,
        transportaionId: this.transportaionId,
      };
      this.projectFacade.locationProcessActions(payload, this.isCheckUpdateOrigin ? 'edit' : 'add');
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
      this.scenarioAddEditForm.controls['origin'].reset();
    }
  }

  async getCalculateDisForNextRecordProduct(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecordProduct = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistanceProduct() {
    this.projectFacade.locationProcessProductData$.pipe(take(1)).subscribe(async (data: any) => {
      const startIndex = data.findIndex(
        (item: any) => item.index === this.projectFilleditDataProduct.index
      ); // Index to start checking after
      if (this.isCheckUpdateDestinationProduct && startIndex < data.length - 1) {
        let destinationNextRecord =
          data[
            data.findIndex((item: any) => item.index === this.projectFilleditDataProduct.index) + 1
          ];
        const lastItemNextRecord = this.scenarioAddEditForm.value.destinationProduct;
        try {
          await this.getCalculateDisForNextRecordProduct(
            lastItemNextRecord.name,
            destinationNextRecord
          );
          Object.freeze(destinationNextRecord);
          const objCopy = { ...destinationNextRecord };
          objCopy.distance = this.setManualLocationDisForNextRecordProduct;
          destinationNextRecord = objCopy;
          this.projectFacade.locationProductProcessActions(destinationNextRecord, 'edit');
        } catch (error) {
          // Handle error, e.g., log it or show a user-friendly message.
          console.error('Error:', error);
        }
      }
    });
  }

  deleteSetDistanceRecordProduct(allRecorsds: any, deleteRecord: any) {
    this.projectFacade.locationProcessProductData$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (!!belowRecord) {
            await this.getCalculateDisForNextRecordProduct(aboveRecord.originName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecordProduct;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacade.locationProductProcessActions(belowRecord, 'edit');
          }
        }
      });
  }

  async setDestinationProduct() {
    this.setDestinationProducsubmitted = true;

    if (!this.scenarioAddEditForm.controls['destinationProduct']?.value?.hasOwnProperty('name')) {
      this.disableDestinationProduct = true;
    } else if (
      !!this.scenarioAddEditForm.controls['transportModeForLocationProduct'].value &&
      !!this.scenarioAddEditForm.controls['destinationProduct'].value
    ) {
      if (
        this.isCheckUpdateDestinationProduct &&
        this.scenarioAddEditForm.controls['distanceManulaLocationProduct'].value == 0
      ) {
        return;
      }
      if (
        (this.scenarioAddEditForm.controls['destinationProduct']?.value?.name?.includes('Port') &&
          (this.lastItemProduct?.originName?.includes('Port') ||
            this.lastItemProduct?.name?.includes('Port')) &&
          this.transportModeNameProduct?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrixProduct(this.lastItemProduct);
      } else {
        !!this.transportModeIdProduct &&
          (await this.calculateDistanceProduct(this.lastItemProduct));
      }

      if (this.messageTypeProduct != 1) {
        if (
          (this.scenarioAddEditForm.value.destinationProduct?.idStr ||
            this.scenarioAddEditForm.value.destinationProduct?.originId) ==
            this.projectFilleditDataProduct?.originId &&
          this.transportModeIdProduct == this.projectFilleditDataProduct?.transportModeId
        ) {
          this.setApiResDistanceProduct = true;
        }
        !!this.projectFilleditDataProduct?.originId &&
          this.scenarioAddEditForm.value.destinationProduct.idStr !=
            this.projectFilleditDataProduct?.originId &&
          this.changeNextRecordDistanceProduct();
        this.disableDestinationProduct = false;
        const payload: any = {
          originName: this.scenarioAddEditForm.controls['destinationProduct'].value.name,
          persanteageMassLoad: this.percenteageMassLoadProd || 0,
          transportModeName:
            this.scenarioAddEditForm.controls['transportModeForLocationProduct'].value?.name,
          transportModeId:
            this.scenarioAddEditForm.controls['transportModeForLocationProduct'].value?.id,
          customTruckId: !!this.transportModeIdProduct
            ? this.transportModeIdProduct
            : this.projectFilleditDataProduct.transportModeIdProduct,
          description: this.isCustomTruckProduct
            ? 'Truck.png'
            : this.scenarioAddEditForm.controls['transportModeForLocationProduct'].value
                ?.description,
          originId:
            this.scenarioAddEditForm.controls['destinationProduct'].value?.idStr ||
            this.scenarioAddEditForm.controls['destinationProduct'].value?.originId,
          id: this.fillingData.id,
          isCustomTruck: this.isCustomTruckProduct,
          productTransportaionId: this.productTransportaionId,
        };
        if (this.isCheckUpdateDestinationProduct) {
          payload['index'] = this.projectFilleditDataProduct?.index;
        }
        const newManualLocationDisatance =
          this.scenarioAddEditForm.controls['distanceManulaLocationProduct'].value;
        const getDisType =
          typeof this.projectFilleditDataProduct?.distance == 'string' &&
          !!this.projectFilleditDataProduct?.distance
            ? this.projectFilleditDataProduct?.distance?.substring(
                this.projectFilleditDataProduct.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);
        if (this.transportModeNameProduct?.toLowerCase() == commonEnum.shipName) {
          payload['distance'] =
            this.isCheckUpdateDestinationProduct && this.setApiResDistanceProduct
              ? newVal
              : this.seaDistanceProduct;
        } else {
          payload['distance'] =
            this.isCheckUpdateDestinationProduct && this.setApiResDistanceProduct
              ? newVal
              : this.setManualLocationDis;
        }

        payload['isCheckManualDisProduct'] = false;
        this.projectFacade.locationProductProcessActions(
          payload,
          this.isCheckUpdateDestinationProduct ? 'edit' : 'add'
        );
        this.setDestinationProducsubmitted = false;
        this.isCheckUpdateDestinationProduct = false;
        this.setApiResDistanceProduct = false;
        this.projectFilleditDataProduct = null;
        this.scenarioAddEditForm.controls['destinationProduct'].reset();
        this.scenarioAddEditForm.controls['transportModeForLocationProduct'].reset();
        this.messageTypeProduct = 0;
        this.location = null;
        this.isValidPortProduct = '';
      } else if (this.messageTypeProduct == 1) {
        this.scenarioAddEditForm.controls['transportModeForLocationProduct'].reset();
        this.setDestinationProducsubmitted = false;
        this.messageTypeProduct = 0;
      } else {
        this.setDestinationProducsubmitted = true;
      }
    }
  }

  setLocationProduct() {
    // For setting Origin in Product
    this.setOriginProductsubmitted = true;

    if (!this.scenarioAddEditForm.controls['originProduct']?.value?.hasOwnProperty('name')) {
      this.disableOriginProduct = true;
    } else if (!!this.scenarioAddEditForm.controls['originProduct'].value) {
      const payload = {
        originName: !!this.location ? this.location : this.projectFilleditDataProduct.originName,
        originId: this.cityId,
        productTransportaionId: this.productTransportaionId,
      };
      this.projectFacade.locationProductProcessActions(
        payload,
        this.isCheckUpdateOriginProduct ? 'edit' : 'add'
      );
      this.scenarioAddEditForm.controls['originProduct'].reset();
      this.setOriginProductsubmitted = false;
      this.checkIsOrginBtnProduct = false;
      this.isCheckUpdateOriginProduct = false;
    }
  }

  getMapingData(ele: any) {
    let mappingData = ele.productLocationTransportationItems
      .concat(ele.productDistanceTransportationItems)
      .sort((item1: any, item2: any) => item1.parentOrder - item2.parentOrder);
    let uniqueParents = [...new Set(mappingData.map((item: any) => item?.parentOrder))].sort(
      (a: any, b: any) => a - b
    );
    let parentMapping: any = {};
    uniqueParents.forEach((value: any, index: any) => {
      parentMapping[value] = index + 1;
    });

    // Step 3: Transform the original array using the mapping, keeping all properties intact
    let transformedData = mappingData.map((item: any) => ({
      ...item,
      parentOrder: parentMapping[item.parentOrder],
    }));

    return transformedData;
  }
  getMapingDataComponent(ele: any) {
    let mappingData = ele.locationTransportationItems
      .concat(ele.distanceTransportationItems)
      .sort((item1: any, item2: any) => item1.parentOrder - item2.parentOrder);
    let uniqueParents = [...new Set(mappingData.map((item: any) => item?.parentOrder))].sort(
      (a: any, b: any) => a - b
    );
    let parentMapping: any = {};
    uniqueParents.forEach((value: any, index: any) => {
      parentMapping[value] = index + 1;
    });

    // Step 3: Transform the original array using the mapping, keeping all properties intact
    let transformedData = mappingData.map((item: any) => ({
      ...item,
      parentOrder: parentMapping[item.parentOrder],
    }));

    return transformedData;
  }

  onSave(
    fillingProcessItems: any,
    locationProcessProductData: any,
    distanceProcessProductData: any,
    replicaLocation: any,
    replicaDistance: any,
    componentProcessData: any,
    productProcessData: any
  ) {
    this.submitted = true;
    if (this.scenarioAddEditForm.controls['productPercentageLoss'].invalid) {
      return;
    } else if (this.scenarioAddEditForm.controls['productLoss'].valid) {
      if (this.selectLocation) {
        locationProcessProductData = locationProcessProductData;
        distanceProcessProductData = [];
        this.customScenarioId = undefined;
      } else if (this.selectDistance) {
        distanceProcessProductData = distanceProcessProductData;
        locationProcessProductData = [];
        this.customScenarioId = undefined;
      } else {
        locationProcessProductData = [];
        distanceProcessProductData = [];
      }
      componentProcessData = cloneDeep(componentProcessData);
      let tempCompData: any = [];
      componentProcessData.forEach((ele: any, i: any) => {
        let productData: any = {};
        const allTransportRec = this.getMapingDataComponent(ele);
        let location: any = [];
        let distance: any = [];
        let custom: any = [];

        // Grouping the records based on transport id
        allTransportRec.forEach((item: any) => {
          switch (item.transportaionId || item.transportationId) {
            case 2:
              location.push(item);
              break;
            case 3:
              distance.push(item);
              break;
            default:
              custom.push(item);
              break;
          }
        });
        ele.locationTransportationItems = location;
        ele.distanceTransportationItems = distance;
        productData['transportaionId'] = ele.transportaionId;
        productData['componentId'] = Number(ele?.idStr) || Number(ele.componentId);
        productData['locationTransportationItems'] = ele.locationTransportationItems;
        productData['distanceTransportationItems'] = ele.distanceTransportationItems;
        productData['customTransportScenarioId'] = ele.customTransportScenarioId;
        if (ele.customTransportScenarioId) {
          productData['customParentOrderNo'] = 1;
        }
        tempCompData.push(productData);
        location = [];
        distance = [];
      });
      let tempProductData: any = [];
      productProcessData = cloneDeep(productProcessData);
      productProcessData.forEach((ele: any) => {
        let productData: any = {};
        const allTransportRec = this.getMapingData(ele);
        let location: any = [];
        let distance: any = [];
        let custom: any = [];

        // Grouping the records based on transport id
        allTransportRec.forEach((item: any) => {
          switch (item.productTransportaionId || item.transportationId) {
            case 2:
              location.push(item);
              break;
            case 3:
              distance.push(item);
              break;
            default:
              custom.push(item);
              break;
          }
        });
        ele.productLocationTransportationItems = location;
        ele.productDistanceTransportationItems = distance;
        productData['productId'] = ele.productId;
        productData['productTransportaionId'] = ele.transportationId || ele.productTransportaionId;
        productData['productLocationTransportationItems'] = ele.productLocationTransportationItems;
        productData['productDistanceTransportationItems'] = ele.productDistanceTransportationItems;
        productData['customTransportScenarioId'] = ele.productCustomTransportScenarioId;
        if (ele.productCustomTransportScenarioId) {
          productData['customParentOrderNo'] = 1;
        }
        tempProductData.push(productData);
        location = [];
        distance = [];
      });
      const fillingPayload: any = {
        id: this.fillingData.id || 0,
        scenarioId: this.scenarioId,
        productId: this.productId || this.fillingData?.productId, // CHECK ONCE FLOW IS COMPLETE
        projectId: this.projectId,
        percentageProductLoss: this.scenarioAddEditForm.controls['productPercentageLoss'].value,
        productlossId: this.scenarioAddEditForm.controls['productLoss'].value?.id,
        fillingProcessItems: fillingProcessItems,
        fillingTempDatalistIteams: tempCompData,
        productTransportationItems: tempProductData,
        costPerPackage: this.scenarioAddEditForm.controls['costPerPackage'].value?.id,
        fillingProcessCountryId: this.selectedCountry?.id || null,
      };
      if (this.secondaryMarketDropdown) {
        fillingPayload['percentageOfReusedProduct'] =
          this.scenarioAddEditForm.controls['secondaryMarket'].value?.name ||
          this.scenarioAddEditForm.controls['secondaryMarket'].value;
      } else {
        fillingPayload['percentageOfReusedProduct'] = 0;
      }
      this.saveNewMyProjectFillingEvent.emit(fillingPayload);
      this.modal.close();
      this.projectFacade.clearFillingProcess();
      this.projectFacade.clearDistanceProcess();
      this.projectFacade.clearFreightProcess();
      this.projectFacade.clearLocationProcessProduct();
      this.projectFacade.clearDistanceProcessProduct();
      this.projectFacade.clearFreightProcessProduct();
      this.projectFacade.clearLocationProcess();
      this.location = null;
      this.projectFacade.clearFillDataComponentErr();
      this.projectFacade.clearFillDataProductErr();
    }
  }

  closePopup(step: string) {
    switch (step) {
      case 'one':
        this.popover.close();
        this.transportPopover.open();
        break;
      case 'two':
        this.transportPopover.close();
        this.locationPopover.open();
        scrollToSpecific('location-popover');
        break;
      case 'three':
        this.locationPopover.close();
        this.lossPopup.open();
        break;
      case 'four':
        this.isTourActive = false;
        this.lossPopup.close();
        scrollToSpecific('modal-top');
        this.sharedService.updateGuideTourStatus(GuideTourEnum.FillingTour, true).subscribe();
        break;
    }
  }

  goBack(step: string) {
    switch (step) {
      case 'two':
        this.transportPopover.close();
        this.popover.open();
        break;
      case 'three':
        this.transportPopover.open();
        this.locationPopover.close();
        scrollToSpecific('modal-top');
        break;
      case 'four':
        this.locationPopover.open();
        this.lossPopup.close();
        break;
    }
  }

  triggerPopup() {
    setTimeout(() => {
      this.isTourActive = true;
      this.popover.open();
    }, 0);
  }

  closeAllSteps(stepNum: any) {
    this.isTourActive = false;
    this.lossPopup.close();
    this.locationPopover.close();
    this.transportPopover.close();
    this.popover.close();
    this.sharedService.updateGuideTourStatus(GuideTourEnum.FillingTour, false, stepNum).subscribe();
  }

  ngOnDestroy() {
    this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
    this.projectFacade.clearManualTransportDistanceError();
    this.searchSubject.complete();
  }
}
